export const APP_TITLE:string = `Onsite Action Centre`;
export const FOOTER_TEXT:string = `Onsite Action Centre &copy; ${new Date().getFullYear()}`;
export const QUICK_CHAT_TITLE: string=`Onsite Action Centre`;
export const LIGHT_THEME_LOGO_PATH: string=`images/logo/logo.png`;
export const DARK_THEME_LOGO_PATH: string=`images/logo/logo.png`;
export const SMALL_LOGO_NO_TEXT_PATH: string=`images/logo/logo.png`;
export const LOGO_ALT_TEXT: string=`Onsite Logo`;
export const EXPORT_FILE_NAME: string=`list-export`;